import type { LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

interface SidebarGroupIconProps {
  groupKey: string;
  icon: LucideIcon;
  label: string;
  isActive: boolean;
  hasActiveChild: boolean;
  collapsed: boolean;
  onClick: () => void;
}

export function SidebarGroupIcon({
  groupKey,
  icon: Icon,
  label,
  isActive,
  hasActiveChild,
  collapsed,
  onClick,
}: SidebarGroupIconProps) {
  return (
    <button
      type="button"
      data-testid={`sidebar-group-${groupKey}`}
      aria-expanded={isActive}
      onClick={onClick}
      title={collapsed ? label : undefined}
      className={cn(
        'flex items-center gap-3 w-full px-3 py-2.5 rounded-md text-sm font-medium transition-colors',
        isActive || hasActiveChild
          ? 'bg-gray-100 text-gray-900 dark:bg-slate-800 dark:text-slate-100'
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100',
      )}
    >
      <Icon className="h-5 w-5 shrink-0" />
      {!collapsed && <span className="truncate">{label}</span>}
    </button>
  );
}
